import {Texts as BizkeyTechTexts} from '../../../@bizkeytech'


/**
 * @inheritDoc
 */
class Texts extends BizkeyTechTexts {

}

export default Texts;
